import { Calendar } from '@fullcalendar/core';
import interactionPlugin from '@fullcalendar/interaction';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import datePicker from 'vue-bootstrap-datetimepicker';
import moment from 'moment';

Vue.component('calendar', {
    props: ['client', 'editable'],

    components: {
        datePicker
    },

    data () {
        return {
            calendar: null,

            options: [],

            filters: {
                admin: '',

                task_type: 'any',

                client: '',

                search: ''
            },

            date: {
                start: '',
                end: ''
            },

            loading: false,

            task: null,

            deleting: false,

            deleteReason: '',

            completing: false,

            createForm: {
                lead: '',
                start: '',
                end: '',
                title: '',
                type: 'reminder'
            },

            alert: null
        };
    },

    mounted () {
        moment().utcOffset(0, true).format();
        this.filters.client = this.client;

        let defaultView = (localStorage.getItem("fcDefaultView") !== null ? localStorage.getItem("fcDefaultView") : "timeGridWeek");

        this.calendar = new Calendar(document.getElementById('calendar'), {
            plugins: [
                interactionPlugin,
                dayGridPlugin,
                timeGridPlugin,
                listPlugin
            ],

            header: {
                left: 'prev,next today',
                center: 'title',
                // right: 'listMonth'
                // right: 'dayGridMonth,timeGridWeek,timeGridDay,listMonth'
            },

            defaultView: 'listMonth',
            // defaultView: defaultView,

            navLinks: true,

            editable: true,

            events: this.getCalendarItems,

            eventClick: this.getEvent,

            eventDrop: this.calendarEvent,

            eventResize: this.calendarEvent,

            eventRender (info) {
                if (info.event.extendedProps.contact_name != null) {
                    $(info.el).append('<td class="fc-widget-content"><span class="badge badge-pill badge-warning">' + info.event.extendedProps.contact_name + '</span></td>');
                } else {
                    $(info.el).append('<td class="fc-widget-content"></td>');
                }

                if (info.event.extendedProps.quote_id > 0) {
                    $(info.el).append('<td class="fc-widget-content"><a href="/admin/quotes/edit/' + info.event.extendedProps.quote_id + '" class="badge badge-pill badge-info">#' + info.event.extendedProps.quote_id + '</a></td>');
                } else {
                    $(info.el).append('<td class="fc-widget-content"></td>');
                }

                if (info.event.extendedProps.client_name != null) {
                    $(info.el).append('<td class="fc-widget-content"><span class="badge badge-pill badge-success">' + info.event.extendedProps.client_name + '</span></td>');
                } else {
                    $(info.el).append('<td class="fc-widget-content"></td>');
                }

                if (info.event.extendedProps.user_id != null) {
                    $(info.el).append('<td class="fc-widget-content"><span class="badge badge-pill badge-primary">' + info.event.extendedProps.assignee + '</span></td>');
                } else {
                    $(info.el).append('<td class="fc-widget-content"></td>');
                }

                setTimeout(() => {
                    $('.fc-widget-header').attr('colspan', 7);
                }, 100);
            },

            viewSkeletonRender (view, element) {
                localStorage.setItem("fcDefaultView", view.view.type);
            },

            dateClick: this.create
        });

        this.calendar.render();

        $('#task').on('hidden.bs.modal', () => {
            this.task.id = null;
            this.loading = false;
            this.completing = false;
            this.deleting = false;

            this.alert = null;
        });

        $('#create').on('hidden.bs.modal', () => {
            this.createForm.start = '';
            this.createForm.end = '';
            this.createForm.type = '';
            this.createForm.title = '';
            this.createForm.notes = '';
            this.createForm.lead = '';

            this.alert = null;
        });
    },

    methods: {
        getCalendarItems (e) {
            return axios.get('/api/tasks', {
                params: {
                    ...this.filters
                }
            }).then(response => {
                let events = [];

                for (let event of response.data) {
                    let color = '#ffc107';

                    switch (event.status) {
                        case 'complete':
                            color = '#28a745';
                            break;
                        case 'overdue':
                            color = '#dc3545';
                            break;
                    }

                    events.push({
                        ...event,
                        // title: 'test <span class="badge badge-primary">Test</span>',
                        backgroundColor: color,
                        borderColor: color
                    });
                }

                return events;
            });
        },

        filterEvents () {
            this.calendar.refetchEvents();
        },

        getEvent (e) {
            if (this.editable) {
                this.loading = true;
                $('#task').modal('show');

                axios.get('/api/tasks/edit/' + e.event.id).then(response => {
                    this.task = response.data;

                    this.task.start = moment(response.data.start, "YYYY-MM-DD HH:mm:ssZ");
                    this.task.end = moment(response.data.end, "YYYY-MM-DD HH:mm:ssZ");

                    this.loading = false;
                });
            }
        },

        deleteTask () {
            this.loading = true;

            axios.post('/api/tasks/delete/' + this.task.id, {
                reason: this.deleteReason
            }).then(response => {
                $('#task').modal('hide');
                this.calendar.refetchEvents();
            });
        },

        async update () {
            await this.updateRequest(this.task);

            if (this.alert === null) {
                $('#task').modal('hide');
            }
        },

        calendarEvent(e) {
            axios.post('/api/tasks/update_dates/' + e.event.id, {
                id: e.event.id,
                start: moment(e.event.start).format('YYYY-MM-DD HH:mm:ss'),
                end: moment(e.event.end).format('YYYY-MM-DD HH:mm:ss')
            });
        },

        updateRequest (task) {
            this.loading = true;
            this.alert = null;

            return axios.post('/api/tasks/update/' + task.id, {
                ...task,
                start: moment(task.start).format('YYYY-MM-DD HH:mm:ss'),
                end: moment(task.end).format('YYYY-MM-DD HH:mm:ss')
            }).then(response => {
                this.calendar.refetchEvents();
            }).catch(errors => {
                this.alert = {
                    type: "error",
                    message: errors.response.data.message,
                    errors: errors.response.data.errors
                };
            }).then(() => {
                this.loading = false;
            });
        },

        complete () {
            this.loading = true;

            axios.post('/api/tasks/complete/' + this.task.id).then(response => {
                this.calendar.refetchEvents();

                $('#task').modal('hide');
            });
        },

        create (e) {
            let start = moment(e.date);

            if (localStorage.getItem("fcDefaultView") === 'dayGridMonth') {
                let now = moment();

                start.set({
                    hour: now.get('hour'),
                    minute: now.get('minute'),
                    second: now.get('second'),
                });
            }

            let end = moment(start).add(1, 'hour');

            this.createForm.start = start;
            this.createForm.end = end;

            $('#create').modal('show');
        },

        store() {
            this.loading = true;
            this.alert = null;

            axios.post('/api/tasks/create', {
                ...this.createForm,
                quote_id: this.createForm.lead != null ? this.createForm.lead.quote_id : ''
            }).then((response) => {
                this.calendar.refetchEvents();
                $('#create').modal('hide');
            }).catch(errors => {
                this.alert = {
                    type: "error",
                    message: errors.response.data.message,
                    errors: errors.response.data.errors
                };
            }).then(() => {
                this.loading = false;
            });
        },

        fetchLeads (search, loading) {
            loading(true);

            axios.get('/api/leads', {
                params: {
                    search
                }
            }).then(response => {
                this.options = response.data;

                loading(false);
            });
        }
    },

    computed: {
        exportFilters () {
            let query = [];

            if (this.calendar !== null) {
                query.push('from=' + moment(this.calendar.view.activeStart).format("YYYY-MM-DD HH:mm"));
                query.push('to=' + moment(this.calendar.view.activeEnd).format("YYYY-MM-DD HH:mm"));
            }

            for (let f in this.filters) {
                if (this.filters[f] != '') {
                    query.push(f + '=' + this.filters[f]);
                }
            }

            return query.length > 0 ? '?' + query.join('&') : '';
        }
    }
});